import { Image } from './image'
import React from 'react'

export const Culture = (props) => {
  return (
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Culture Night</h2>
          <p>
            The AMPC code presented a showcase during Culture Night 2023. This
            showcase was a huge success. Many people in attendence gave positive
            feedback about their musical experience. The showcase took place in
            the North Wing Council room in University College Cork's historical
            Main Quad. The showcase was open to all and a wide variety of people
            from different backgrounds came to listen to the protein music
            presented. Ten naturally significant proteins were chosen for the
            presentation. The music associated with each protein was also made
            available on SoundCloud. Some images from the showcase are presented
            below.
          </p>
        </div>
        <div className="row">
          <div className="portfolio-items">
            {props.data
              ? props.data.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                  >
                    <Image
                      title={d.title}
                      largeImage={d.largeImage}
                      smallImage={d.smallImage}
                    />
                  </div>
                ))
              : 'Loading...'}
          </div>
        </div>
      </div>
    </div>
  )
}
